import React from 'react'
import { Navigate } from 'react-router-dom'

function ControlComponent({ component: Component, ...props }) {
    const approvedRole = props.approvedRole(props.role)
    return <>{approvedRole ? <Component {...props} /> : <Navigate to="/" />}</>
}
export default ControlComponent
